import { render, staticRenderFns } from "./playorpause.vue?vue&type=template&id=8ef9c3c4&scoped=true&"
import script from "./playorpause.vue?vue&type=script&lang=js&"
export * from "./playorpause.vue?vue&type=script&lang=js&"
import style0 from "./playorpause.vue?vue&type=style&index=0&id=8ef9c3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef9c3c4",
  null
  
)

export default component.exports